module.exports = __webpack_public_path__ + "img/kubernetes.4655ae6f.png";